/**
 * Email Tracker by Mailtrack®
 *
 * Email open-tracking; resources scoped to Gmail, so only Google can enumerate it.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker, so detection falls back to resource probing.
 * Manifest verified against version 12.82.3.
 */
import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'ndnaehgpjlnokgebbaldlmgkapkpjkkb';
export const mailtrack: ExtensionDefinition = {
  id: ID,
  name: "Email Tracker by Mailtrack®",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 3000000,
  requiredOrigin: 'https://mail.google.com',
  notes: "Email open-tracking; resources scoped to Gmail, so only Google can enumerate it.",
  signals: [
    { id: 'war-images-mailtrack-crx-sprite-2x-png', kind: 'web-accessible-resource',
      description: 'Load images/mailtrack-crx-sprite_2x.png via <img>, exposed only to https://mail.google.com.',
      weight: 1, run: () => probeImage(ID, 'images/mailtrack-crx-sprite_2x.png') },
    { id: 'war-images-expand-tracking-png', kind: 'web-accessible-resource',
      description: 'Load images/expand-tracking.png via <img>, exposed only to https://mail.google.com.',
      weight: 0.5, run: () => probeImage(ID, 'images/expand-tracking.png') },
  ],
};
